import React from 'react'
import AddIcon from '@mui/icons-material/Add';
function ButtonPlus({onClick, name}) {
  return (
    <>
    <button 
      className=' bg-[#F5F1FE]   px-4 py-3 border-[#E6DAFC] text-[14px] rounded-lg font-bold text-[#8046F2]'
      onClick={onClick}
      type='submit' 
     >{name} <AddIcon/></button>   
    </>
  )
}

export default ButtonPlus